import { SendDealDocumentsTracking } from '@/components/compliance-page/sendDealDocumentsTrackingPage';
import useRefresh from '@/hooks/use-refresh';
import { Helmet as Head } from 'react-helmet';

const SendDealDocumentsTrackingPage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>Send Deal Documents Tracking</title>
      </Head>
      <SendDealDocumentsTracking />
    </>
  );
};

export default SendDealDocumentsTrackingPage;
